import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { toPascalCase } from '@cli-utils/text.js'
import { renderGenDistinctFilesServerActionTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-distinct-files.js'

export function genDistinctFiles(ctx: EntityCtx): Array<{ name: string; content: string }> {
  if (!ctx.hasFilters) return []

  return ctx.filters
    .filter((filter) => filter.source === 'distinct')
    .map((filter) => {
      const fieldPascal = toPascalCase(filter.key)
      const kebabField = filter.key
        .replace(/([A-Z])/g, '-$1')
        .toLowerCase()
        .replace(/^-/, '')
      const kebabPlural = ctx.plural
        .replace(/([A-Z])/g, '-$1')
        .toLowerCase()
        .replace(/^-/, '')

      return {
        name: `get-distinct-${kebabPlural}-${kebabField}.ts`,
        content: renderGenDistinctFilesServerActionTemplate({
          ctxTableVar: ctx.tableVar,
          ctxCacheReadImport: ctx.cacheReadImport,
          ctxCamelPlural: ctx.camelPlural,
          ctxPlural: ctx.Plural,
          fieldPascal: fieldPascal,
          ctxCacheLifeLine: ctx.cacheLifeLine,
          filterField: filter.field,
          ctxPluralText: ctx.plural
        })
      }
    })
}
